"use client";

import React from "react";
import MobileHero from "./MobileHero";
import MobileFeatures from "./MobileFeatures";
import MobileCTAButton from "./MobileCTAButton";
import MobileHowItWorks from "./MobileHowItWorks";
import MobileFeatureShowcase from "./MobileFeatureShowcase";
import MobileProSection from "./MobileProSection";
import MobileVideoCarousel from "./MobileVideoCarousel";
import MobileContactUs from "./MobileContactUs";
import MobileFooter from "./MobileFooter";
import USCoverageMapMobile from "../USCoverageMapMobile";
import { useState, useEffect } from "react";
import {
	createCheckoutSessionWithAuth,
	STRIPE_PRO_PRICE_ID,
} from "@/services/stripe-api";
import { getConfig } from "@/services/enrichment-api";
import { toast } from "sonner";
import Link from "next/link";

export default function MobileLandingPageContent() {
	const [isUpgrading, setIsUpgrading] = useState(false);
	const [enrichmentEnabled, setEnrichmentEnabled] = useState(false);

	useEffect(() => {
		getConfig()
			.then((c) => setEnrichmentEnabled(!!c.enrichment))
			.catch(() => {});
	}, []);

	const handleUpgrade = async () => {
		setIsUpgrading(true);
		try {
			const { url } =
				await createCheckoutSessionWithAuth(STRIPE_PRO_PRICE_ID);
			window.location.href = url;
		} catch (error) {
			console.error("Failed to start checkout:", error);
			// Don't show error if redirecting to login
			if (
				error instanceof Error &&
				error.message !== "Redirecting to login"
			) {
				toast.error("Failed to start checkout. Please try again.");
			}
			setIsUpgrading(false);
		}
	};

	return (
		<div className="bg-[#16251c] min-h-screen w-[100%] mx-auto overflow-x-hidden">
			{/* Container with max width for mobile */}
			<div
				className="w-[90%] mx-auto py-4"
				style={{
					display: "flex",
					flexDirection: "column",
					gap: "2rem",
					alignItems: "center",
				}}
			>
				<MobileHero />
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						width: "90%",
						alignItems: "center",
						gap: "2rem",
					}}
				>
					<MobileFeatures />
					<MobileFeatures />
					<MobileCTAButton
						onClick={handleUpgrade}
						isUpgrading={isUpgrading}
					/>
					{enrichmentEnabled && (
						<Link
							href="/enrich"
							className="w-full max-w-[20rem] py-3 px-4 rounded-full border-2 border-[#A7FF5E] text-[#A7FF5E] font-bold text-center"
						>
							Data Enrichment
						</Link>
					)}
					<section id="how-it-works" className="w-full">
						<MobileHowItWorks />
					</section>
					<MobileFeatureShowcase />
					<div style={{ width: "100%" }}>
						<USCoverageMapMobile />
					</div>
					<section id="payment" className="w-full">
						<section id="payment" className="w-full">
							<MobileProSection
								onClick={handleUpgrade}
								isUpgrading={isUpgrading}
							/>
						</section>
					</section>
					<MobileVideoCarousel />
				</div>
			</div>
			<MobileContactUs />
			<MobileFooter />
		</div>
	);
}
